import React from "react";
import { ChevronDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { cn } from "../lib/utils";

const RootToggle = ({
  options,
  value,
  onValueChange,
  placeholder = "Ordenar por",
  className,
  ...props
}) => {
  const [open, setOpen] = React.useState(false);

  const selected = React.useMemo(
    () => options.find((option) => option.value === value),
    [options, value]
  );

  const handleSelect = (nextValue) => {
    setOpen(false);
    onValueChange?.(nextValue);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger
        className={cn(
          "flex h-9 items-center gap-2 rounded-full border border-border px-4 text-xs font-semibold leading-none text-foreground",
          "bg-transparent hover:bg-muted hover:text-foreground",
          className
        )}
        {...props}
      >
        <span className="flex-1 text-left">{selected ? selected.title : placeholder}</span>
        <ChevronDown className="h-4 w-4 text-muted-foreground" />
      </PopoverTrigger>
      <PopoverContent className="w-[var(--radix-popover-trigger-width)] p-0">
        <div className="overflow-hidden rounded-md">
          {options.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => handleSelect(option.value)}
              className={cn(
                "flex w-full items-start gap-2 px-3 py-2 text-left text-sm transition-colors",
                value === option.value
                  ? "bg-muted text-foreground"
                  : "hover:bg-muted hover:text-foreground"
              )}
            >
              {option.icon ? option.icon : null}
              <span className="flex-1">
                <span className="block font-medium">{option.title}</span>
                {option.description ? (
                  <span className="block text-xs text-muted-foreground">
                    {option.description}
                  </span>
                ) : null}
              </span>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default RootToggle;
